module.exports = {
    "FOREST PARK BLVD": [
        {
            "address": "1000 FOREST PARK BLVD STE 200",
            "display_address": "1",
            "sort_house": "1000",
            "sort_street": "FOREST PARK BLVD STE 200~^~ FORT WORTH~^~76110",
            "zip_code": "76110"
        },
        {
            "address": "1009 FOREST PARK BLVD",
            "display_address": "1",
            "sort_house": "1009",
            "sort_street": "FOREST PARK BLVD~^~ FORT WORTH~^~76110",
            "zip_code": "76110"
        }
    ],
    "W ROSEDALE ST S": [
        {
            "address": "2314 W ROSEDALE ST S",
            "display_address": "1",
            "sort_house": "2314",
            "sort_street": "W ROSEDALE ST S~^~ FORT WORTH~^~76110",
            "zip_code": "76110"
        },
        {
            "address": "2320 W ROSEDALE ST S",
            "display_address": "1",
            "sort_house": "2320",
            "sort_street": "W ROSEDALE ST S~^~ FORT WORTH~^~76110",
            "zip_code": "76110"
        },
        {
            "address": "2324 W ROSEDALE ST S",
            "display_address": "1",
            "sort_house": "2324",
            "sort_street": "W ROSEDALE ST S~^~ FORT WORTH~^~76110",
            "zip_code": "76110"
        }
    ]
};